export default function InstallationsMockService($http) {
  'ngInject';
  this.getInstallations = () => $http.get('./app/fixtures/installations.json');
  this.getInstallationByequipID = () => $http.get('./app/fixtures/installations.detail.json');
}